import builder from '@builder.io/react'

export const initBuilderIo = () =>
  builder.init(process.env.REACT_APP_BUILDER_IO_API_KEY || '')
